import React, { Component } from "react";
import {Helmet} from 'react-helmet'

class PageHelmet extends Component{
    render(){
        return(
            <React.Fragment>
                <Helmet>
                    <title>{this.props.pageTitle === '' ? '' : this.props.pageTitle + " || "} AB Growth Strategies </title>
                    <meta name="description" content="AB Growth Strategies Ltda. | Crescimento Inteligente, Sucesso Estratégico" />
                </Helmet>
            </React.Fragment>
        )
    }
}


export default PageHelmet;
